import { useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { useLocaleContext } from '@localization/context/LocaleContext';
import { addError, addSuppressedError } from '@shared/utils/logger';
import { reactDatepickerLocaleImports } from '@shared/core/i18n/utils';

export const useReactDatePickersLocale = () => {
  const [isRegistered, setIsRegistered] = useState(false);
  const locale = useLocaleContext();
  const languageCode = locale.language.split('-')[0];

  useEffect(() => {
    const loadAndRegisterLocale = async () => {
      const importFn = reactDatepickerLocaleImports[languageCode];

      try {
        const localeModule = await importFn?.();
        if (localeModule) {
          registerLocale(languageCode, localeModule.default);
        } else {
          addSuppressedError('Empty Results', {
            source: `Failed to load date-fns locale for ${languageCode}`,
            context: 'useReactDatePickersLocale',
            languageCode,
          });
        }
        setIsRegistered(true);
      } catch (error) {
        addError(error, {
          source: `Failed to load date-fns locale for ${languageCode}`,
          context: 'useReactDatePickersLocale',
          languageCode,
        });
      }
    };
    loadAndRegisterLocale();
  }, [languageCode]);

  return { languageCode, isRegistered };
};
